import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UtmifyScript } from './components/UtmifyScript';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-white text-stone-900" data-id="element-0" data-mp="28tw62tsgwo4i">
      <MetaPixel data-id="element-1" data-mp="28sl5f2ubjwhm" />
      <UtmifyScript data-id="element-2" data-mp="28s2ynca15zvg" />
      <CountdownBar data-id="element-3" data-mp="23vkzcrxgytqi" />
      <main data-id="element-4" data-mp="23u9u0nodldxa">
        <Hero data-id="element-5" data-mp="23ujl6el5pr4k" />
        <StatsBar data-id="element-6" data-mp="23v2sz2h3ez4v" />
        <Difference data-id="element-7" data-mp="23ti7018ugoim" />
        <Recognize data-id="element-8" data-mp="3ik7k0rkruvvx" />
        <WhatsInside data-id="element-9" data-mp="3iiwdijzxza14" />
        <InstantAccess data-id="element-10" data-mp="3ijfv1zlojwem" />
        <Bonuses data-id="element-11" data-mp="3ii4t85bsoyq5" />
        <Offer data-id="element-12" data-mp="3mlawd43m29se" />
        <Guarantee data-id="element-13" data-mp="3ml17xky7saot" />
        <Testimonials data-id="element-14" data-mp="3mk86mzi0yde2" />
        <Faq data-id="element-15" data-mp="3mjq3diwy2ywn" />
      </main>
      <Footer data-id="element-16" data-mp="3rc9e8848zfxr" />
    </div>;
}